interface String {
    replaceAll(match: string, replacement: string);

    trim();

    toNumber();

    toDate();

    isDecimal(): boolean;

    startsWith(search: string): boolean;

    upperFirstLetter(): string;
}

String.prototype.replaceAll = function (match: string, replacement: string) {
    return this.replace(new RegExp(match, 'g'), replacement);
};

String.prototype.trim = function () {
    return this.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
};

String.prototype.toNumber = function () {
    let numberVal = parseInt(this);

    return isNaN(numberVal) ? 0 : numberVal;
};

String.prototype.toDate = function () {
    return new Date(this);
};

String.prototype.isDecimal = function () {
    return (this.indexOf(',') !== -1) || (this.indexOf('.') !== -1);
};

String.prototype.startsWith = function(search) {
    return !this.indexOf(search);
};

String.prototype.upperFirstLetter = function() {
    try {
        if (!this || !this.length) {
            return '';
        }
        return this[0].toUpperCase() + this.slice(1)
    } catch (e) {
        console.log('upperFirstLetter failed: ', e);
        console.log('upperFirstLetter target: ', this);
        return this;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/extensions/string/string.extensions.ts